export { default } from './EventsUserNoticeSubscribeService';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/events/services/EventsUserNoticeSubscribeService/index.js